import {
  Box,
  Button,
  Card,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import api from "../../../components/services/api";
import { useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import mime from "mime";
import { saveAs } from "file-saver";
export default function ReportRevenue() {
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [checkAll, setCheckAll] = useState(true);
  const [loading, setLoading] = useState(false);
  const [toAction, setToAction] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [search, setSearch] = useState({
    startDate: moment().format("yyyy-MM-DD"),
    endDate: moment().add(1, "M").format("yyyy-MM-DD"),
    voyNo: "",
  });

  const columns = [
    { field: "QuotationNo", headerName: "Quotation No.", width: 200 },
    { field: "SaleOrderNo", headerName: "SaleOrder No. ", width: 200 },
    { field: "CustomerName", headerName: "CustomerName", width: 300 },
    { field: "CostDescription", headerName: "Service Description", width: 300 },
    {
      field: "Total",
      headerName: "Total (THB)",
      width: 200,
      renderCell: (value) => {
        return parseFloat(value?.row?.Total, 10)
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,");
      },
    },
    { field: "Status", headerName: "Status", width: 150 },

    // { field: "ETD", headerName: "ETD", width: 200 ,  renderCell: (value) => {
    //     return(
    //       moment(value.row.ETD).format('yyyy/MM/DD')
    //     )

    //   }},
    // { field: "ETDto", headerName: "ETA To", width: 200,
    // renderCell: (value) => {
    //     return(
    //       moment(value.row.ETA).format('yyyy/MM/DD')
    //     )

    //   } },
    // {
    //     field: "Action",
    //     width: 200,
    //     sortable: false,
    //     renderCell: (params) => {
    //       return (
    //         <>

    //           <Button
    //           variant="contained"
    //           style={{ textTransform: "none", backgroundColor: "#007BFF" }}
    //           onClick={async () => {
    //             setLoading(true)
    //             await api.get(`api/report/LadenContainerPlanning/download?VoyNo=${params.row.Voyage}`, {
    //               responseType: "blob",
    //               timeout: 30000
    //             })
    //               .then((blobFile) => {
    //                 const blobFileRes = new File([blobFile?.data], "test.xlsx", {
    //                   type: mime.getType(".xlsx"),

    //                 });

    //                 // window.open(
    //                 //   URL.createObjectURL(blobFileRes, "test.csv"),
    //                 //   "_blank"
    //                 // );
    //                 saveAs(blobFileRes, "Report.xlsx");
    //                 setLoading(false)
    //               });

    //           }}>
    //           download
    //         </Button>

    //         </>
    //       );
    //     },
    //   },
  ];
  const search1 = async () => {
    const params = new URLSearchParams();
    if (dateStart)
      params.append("sdate", moment(dateStart).format("yyyy-MM-DD"));
    if (dateEnd) params.append("edate", moment(dateEnd).format("yyyy-MM-DD"));
    if (toAction) params.append("completeonly", toAction);
    const data = await api.get(`api/report/Revenue/list?${params}`);

    const result = data?.data.map((x, i) => ({
      ...x,
      id: i + 1,
    }));
    setData(result);
  };

  const getdata = async () => {
    const data = await api.get(`api/report/Revenue/list`);

    const result = data?.data.map((x, i) => ({
      ...x,
      id: i + 1,
    }));
    setData(result);
  };

  useEffect(() => {
    getdata();
  }, []);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          รายงานรายได้
        </h6>
        <h3 style={{ marginTop: "10px" }} className="textcolordarkblue">
          Report Revenue
        </h3>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          {/* <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            size="small"
            id="outlined-basic"
            label="Search Voy"
            variant="outlined"
          /> */}
          <FormControl
            size="small"
            sx={{
              width: "15%",
              marginRight: "10px",
            }}
          >
            <InputLabel>ToAction</InputLabel>
            <Select
              label="ToAction"
              value={toAction}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setToAction(e.target.value);
              }}
              // disabled={values.liners !== ""}
            >
              <MenuItem value={false}>All</MenuItem>
              <MenuItem value={true}>Complete</MenuItem>
            </Select>
          </FormControl>
          <DesktopDatePicker
            label="Date Start"
            value={dateStart}
            inputFormat="yyyy/MM/dd"
            onChange={(newValue) => {
              setDateStart(moment(newValue).format("yyyy-MM-DD"));
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <DesktopDatePicker
            label="Date End"
            value={dateEnd}
            inputFormat="yyyy/MM/dd"
            minDate={new Date(dateStart)}
            onChange={(newValue) => {
              setDateEnd(moment(newValue).format("yyyy-MM-DD"));
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                style={{ width: "200px", marginLeft: "10px" }}
                {...params}
              />
            )}
          />
          <Button
            style={{
              backgroundColor: "#0d6efd",
              color: "#fafafa",
              marginLeft: "10px",
            }}
            onClick={search1}
          >
            <SearchIcon />
          </Button>
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              backgroundColor: "#007BFF",
              marginLeft: "10px",
            }}
            onClick={async () => {
              const params = new URLSearchParams();
              if (dateStart)
                params.append("sdate", moment(dateStart).format("yyyy-MM-DD"));
              if (dateEnd) params.append("edate", moment(dateEnd).format("yyyy-MM-DD"));
              if (toAction) params.append("completeonly", toAction);
              await api
                .get(
                  `api/report/Revenue/download/excel?${params}`,
                  {
                    responseType: "blob",
                    timeout: 30000,
                  }
                )
                .then((blobFile) => {
                  const blobFileRes = new File([blobFile?.data], "test.xlsx", {
                    type: mime.getType(".xlsx"),
                  });

                  // window.open(
                  //   URL.createObjectURL(blobFileRes, "test.csv"),
                  //   "_blank"
                  // );
                  saveAs(blobFileRes, "ReportRevenue.xlsx");
                });
            }}
          >
            Download
          </Button>
        </div>
        <Box sx={{ height: "700px", marginTop: "25px" }}>
          <DataGrid
            getRowId={(r) => r.id}
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            hideFooterSelectedRowCount
            disableColumnFilter
            disableColumnMenu
          />
        </Box>
      </Card>
    </LocalizationProvider>
  );
}
